import React, { useEffect } from 'react';
import Header from './components/Header';
import ChatWindow from './components/ChatWindow';
import Footer from './components/Footer';
import './App.css';

function App() {
  useEffect(() => {
    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          const headers = entry.target.querySelectorAll('h2');
          headers.forEach(header => {
            header.classList.add('visible');
          });
          if (entry.target.id === 'chat') {
            const aiTextOverlay = entry.target.querySelector('.ai-gradient-text-overlay');
            if (aiTextOverlay) {
              aiTextOverlay.classList.add('visible');
            }
            // Add delay and fade out the base text
            const aiTextBase = entry.target.querySelector('.ai-gradient-text-base');
            if (aiTextBase) {
              setTimeout(() => {
                aiTextBase.classList.add('fade-out');
              }, 1500); // Match with the overlay's animation time
            }
            // Trigger gradient animation for chat section
            const gradientText = entry.target.querySelector('.ai-gradient-text');
            if (gradientText) {
              // Add a slight delay to make the animation more noticeable
              setTimeout(() => {
                gradientText.classList.add('animate-gradient');
              }, 300);
            }
          }
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: 0.1,
      rootMargin: '-50px 0px'
    });

    // Observe all sections
    const sections = document.querySelectorAll('.section');
    sections.forEach(section => {
      observer.observe(section);
    });

    // Cleanup observer on component unmount
    return () => {
      sections.forEach(section => {
        observer.unobserve(section);
      });
    };
  }, []); // Empty dependency array means this effect runs once after mount

  return (
    <div className="App">
      <Header />

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="video-background">
          <video autoPlay loop muted playsInline className="background-video">
            <source src="videos/morning-mountain-coffee.mp4" type="video/mp4" />
          </video>
          <div className="video-overlay"></div>
        </div>
        <div className="hero-content">
          <h1><span className="ai-gradient-text">Innovating Tomorrow's Intelligence</span></h1>
          <p>At NightHawk AI, we pioneer cutting-edge AI research and deliver innovative applications for a smarter future.</p>
          <a href="#chat" className="btn">Try Our AI</a>
        </div>
      </section>

      {/* Chat Section - Moved above About */}
      <section id="chat" className="section chat">
        <div className="container">
          <h2>Try <span className="ai-gradient-text-container">
                  <span className="ai-gradient-text" data-text="NightHawk AI">NightHawk AI</span>
                </span>
          </h2>
          <ChatWindow />
          <br></br>
          <p className="section-intro">Our model is 3.4x faster* than previous versions</p>
          <p>* Based on internal benchmarks compared to our 2023 model.</p>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="section about">
        <div className="container">
          <h2>About Us</h2>
          <p>NightHawk AI, Incorporated is at the forefront of AI research and application development. Our team is dedicated to transforming ideas into groundbreaking solutions that power the future.</p>
        </div>
      </section>

      {/* Research Section */}
      <section id="research" className="section research">
        <div className="container">
          <h2>Our Research</h2>
          <div className="research-items">
            <div className="research-item neon-box">
              <div className="neon-box-content">
                <h3><span className="ai-gradient-text">Deep Learning</span></h3>
                <p>Exploring advanced neural network architectures and methodologies for intelligent systems.</p>
              </div>
            </div>
            <div className="research-item">
              <h3>Natural Language Processing</h3>
              <p>Innovating in machine understanding and generation of human language.</p>
            </div>
            <div className="research-item">
              <h3>Computer Vision</h3>
              <p>Developing state-of-the-art algorithms to enable machines to see and interpret the world.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section id="applications" className="section applications">
        <div className="container">
          <h2>Our Applications</h2>
          <div className="application-items">
            <div className="application-item">
              <h3>Smart Assistants</h3>
              <p>Building intuitive and responsive digital assistants that enhance productivity.</p>
            </div>
            <div className="application-item">
              <h3>Automation Tools</h3>
              <p>Streamlining business processes through innovative automation solutions.</p>
            </div>
            <div className="application-item">
              <h3>Data Analytics</h3>
              <p>Empowering data-driven decision-making with advanced analytics platforms.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="section contact">
        <div className="container">
          <h2>Contact Us</h2>
          <form action="#" method="post" className="contact-form">
            <input type="text" name="name" placeholder="Your Name" required />
            <input type="email" name="email" placeholder="Your Email" required />
            <textarea name="message" placeholder="Your Message" rows="5" required></textarea>
            <button type="submit" className="btn">Send Message</button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default App;